import { useEffect, useState } from 'react';

import { UpdateIcon } from '@radix-ui/react-icons';

import { Button } from '../ui/button';
import {
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle
} from "../ui/dialog";
import {
    Form,
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from '../ui/form';
import { Input } from '../ui/input';
import { toast } from '../ui/use-toast';


import { useForm } from 'react-hook-form';
import api from '../../lib/api';

function CreateNewClubDialog({ close, isOpen, onClubCreated }) {
    const form = useForm();
    const [preferredClubName, setPreferredClubName] = useState('');
    const [preferredClubShort, setPreferredClubShort] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    // Submit
    const sendCreationRequest = async (e) => {
        if (isLoading) return; // If loading, return
        e.preventDefault();
        setIsLoading(true); // Set loading to true

        // Send request to create new club
        api.post(`https://skhrf-api.cmdigital.se/v1/clubs/create`, { name: preferredClubName, abbreviation: preferredClubShort })
            .then(response => {
                setIsLoading(false); // Request successful, set loading to false

                toast({
                    title: 'Förening skapad.',
                    description: `${preferredClubName} har skapats och lagts till i systemet.`,
                });
                setPreferredClubName('');
                setPreferredClubShort('');
                onClubCreated(); // Call the callback to fetch clubs
                close(false);
            })
            .catch(error => {
                console.error('Error creating club:' + error?.response?.data?.error); // Log
                setIsLoading(false); // Error occurred, set loading to false
                toast({
                    variant: 'destructive',
                    title: 'Något gick fel.',
                    description: error?.response?.data?.error,
                });
            });
    };

    return (
        <DialogContent>
            <DialogHeader className='text-left'>
                <DialogTitle>Skapa ny förening</DialogTitle>
                <DialogDescription>Ange information för att skapa en ny förening.</DialogDescription>
            </DialogHeader>
            <Form {...form} >
                <form onSubmit={sendCreationRequest} className="flex flex-col gap-6">
                    <FormField
                        control={form.control}
                        name="clubName"
                        render={({ field }) => (
                            <FormItem className='space-y-0 grid gap-2'>
                                <FormLabel>Föreningsnamn</FormLabel>
                                <FormControl>
                                    <Input onChange={(e) => setPreferredClubName(e.target.value)} placeholder='Staffanstorps kaninhoppare' autoComplete='off' />
                                </FormControl>
                                <FormDescription>
                                    Föreningens namn.
                                </FormDescription>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                    <FormField
                        control={form.control}
                        name="clubShort"
                        render={({ field }) => (
                            <FormItem className='space-y-0 grid gap-2'>
                                <FormLabel>Förkortning</FormLabel>
                                <FormControl>
                                    <Input placeholder='ABC' onChange={(e) => setPreferredClubShort(e.target.value)} autoComplete='off' />
                                </FormControl>
                                <FormDescription>
                                    Föreningens förkortade namn.
                                </FormDescription>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                    <div className='grid grid-cols-2 gap-3'>
                        <DialogClose asChild>
                            <Button type='button' variant='secondary'>Avbryt</Button>
                        </DialogClose>
                        <Button type="submit" disabled={isLoading}>
                            {isLoading ? <UpdateIcon className='loader-spinner' /> : <>Skapa förening</>}

                        </Button>
                    </div>
                </form>
            </Form>
        </DialogContent>
    );
};

export default CreateNewClubDialog;